// PizzaRaf's routes. A game, and two screens pushed on top of it.

import { createRouter, createMemoryHistory } from '@ionic/vue-router';
import { gameControllerOutline, helpCircleOutline, settingsOutline } from 'ionicons/icons';

import StackShell from './pages/StackShell.vue';
import GamePage from './pages/GamePage.vue';
import HowToPlayPage from './pages/HowToPlayPage.vue';
import SettingsPage from './pages/SettingsPage.vue';

/** Where the app opens. main.js pushes this. */
export const HOME = '/tabs/game';

export const DESTINATIONS = [
  { name: 'game', label: 'Play', path: '/tabs/game', icon: gameControllerOutline },
  { name: 'how', label: 'How to play', path: '/tabs/how', icon: helpCircleOutline },
  { name: 'settings', label: 'Settings', path: '/tabs/settings', icon: settingsOutline },
];

export const TABS = DESTINATIONS;

export default createRouter({
  history: createMemoryHistory(),
  routes: [
    { path: '/', redirect: HOME },
    {
      path: '/tabs/',
      component: StackShell,
      children: [
        { path: '', redirect: HOME },
        { path: 'game', name: 'game', component: GamePage },
        { path: 'how', name: 'how', component: HowToPlayPage },
        { path: 'settings', name: 'settings', component: SettingsPage },
      ],
    },
  ],
});
